<template>
  <section id="products" class="products">
    <div class="container">
      <header class="section-head">
        <h2 class="section-title">产品中心</h2>
        <p class="section-lead">
          覆盖感知、交互、视觉智能与自动化执行，支撑图书馆全链路智慧化
        </p>
      </header>
      <div class="products-grid">
        <article
          v-for="(p, idx) in products"
          :key="p.id"
          class="product-card"
        >
          <router-link :to="detailRoute(p)" class="product-link">
            <div class="product-media" :class="{ 'product-media--ready': imageReady[p.id] }">
              <img
                v-if="p.image"
                class="product-img"
                :src="p.image"
                :alt="p.title"
                :loading="idx < 8 ? 'eager' : 'lazy'"
                decoding="async"
                :fetchpriority="idx === 0 ? 'high' : idx < 8 ? 'auto' : 'low'"
                @load="onTileImageLoad(p.id)"
                @error="onTileImageLoad(p.id)"
              >
              <span v-else class="product-icon" aria-hidden="true">📦</span>
            </div>
            <h3 class="product-title">{{ p.title }}</h3>
            <p class="product-en">{{ p.name_en || p.en || 'PRODUCT' }}</p>
            <p class="product-desc">{{ p.subtitle || p.description || '' }}</p>
          </router-link>
        </article>
      </div>
      <p class="section-cta">
        <router-link to="/products" class="link-more">进入产品中心 →</router-link>
        <router-link :to="{ path: '/', hash: '#contact' }" class="link-more link-more--secondary">获取方案与报价 →</router-link>
      </p>
    </div>
  </section>
</template>

<script>
import { fetchProducts } from '../api/products'

export default {
  name: 'ServicesSection',
  props: {
    prefetchItems: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      products: [],
      imageReady: {}
    }
  },
  async mounted() {
    this.imageReady = {}
    if (Array.isArray(this.prefetchItems) && this.prefetchItems.length) {
      this.products = this.prefetchItems.map((item) => ({ ...item }))
      return
    }
    const list = await fetchProducts()
    this.products = Array.isArray(list) ? list : []
  },
  methods: {
    detailRoute(item) {
      return {
        name: 'product-detail',
        params: { id: String(item.id) }
      }
    },
    onTileImageLoad(id) {
      if (id == null) return
      this.imageReady = { ...this.imageReady, [id]: true }
    }
  }
}
</script>

<style scoped>
.products {
  padding: 100px 0;
  background: #fff;
}

.section-head {
  text-align: center;
  margin-bottom: 48px;
}

.section-title {
  font-size: 42px;
  margin-bottom: 16px;
  color: #0c4a6e;
  font-weight: 700;
}

.section-lead {
  font-size: 17px;
  color: #64748b;
  max-width: 640px;
  margin: 0 auto;
  line-height: 1.75;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 28px;
  max-width: 1200px;
  margin: 0 auto;
}

.product-card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  text-align: center;
  transition: box-shadow 0.25s, border-color 0.25s;
}

.product-card:hover {
  box-shadow: 0 16px 48px rgba(12, 74, 110, 0.1);
  border-color: #bae6fd;
}

.product-link {
  display: block;
  color: inherit;
  padding: 20px 18px 22px;
}

.product-media {
  width: 100%;
  aspect-ratio: 4 / 3;
  margin: 0 auto 16px;
  border-radius: 10px;
  background: #f1f5f9;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.product-media::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(110deg, transparent 0%, rgba(255, 255, 255, 0.55) 45%, transparent 90%);
  background-size: 220% 100%;
  animation: product-media-shimmer 1.35s ease-in-out infinite;
  pointer-events: none;
  z-index: 0;
}

.product-media--ready::after {
  display: none;
}

.product-img {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  opacity: 0;
  transition: opacity 0.35s ease;
}

.product-media--ready .product-img {
  opacity: 1;
}

@keyframes product-media-shimmer {
  0% { background-position: 100% 0; }
  100% { background-position: -100% 0; }
}

.product-icon {
  font-size: 48px;
  display: block;
}

.product-title {
  font-size: 20px;
  color: #0c4a6e;
  font-weight: 600;
  margin-bottom: 6px;
}

.product-en {
  font-size: 12px;
  color: #0284c7;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin: 0 0 14px;
  font-weight: 600;
}

.product-desc {
  font-size: 14px;
  color: #64748b;
  line-height: 1.65;
  margin: 0;
}

.section-cta {
  display: flex;
  flex-wrap: wrap;
  gap: 28px;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
}

.link-more {
  color: #0284c7;
  font-weight: 600;
  font-size: 16px;
}

.link-more:hover {
  color: #0369a1;
}

.link-more--secondary {
  color: #64748b;
}

.link-more--secondary:hover {
  color: #0284c7;
}

@media (max-width: 768px) {
  .section-title {
    font-size: 32px;
  }
}
</style>
